import { RequiredForChoices } from "@/__generated__/schema.graphql.types";
import { getRadioValue } from "@/utils/booking";
import { MedspaInfo } from "@/views/booking/bookingView";

type EnabledFeatures = {
  onlineBookingDepositsV1Enabled: boolean;
  onlyRequireCcForNewClientsEnabled: boolean;
};

const useBookingCCRequiredFlags = (
  medspaConfiguration: MedspaInfo["configuration"],
  isReturningClient: boolean,
  enabledFeatures: EnabledFeatures
) => {
  if (!medspaConfiguration) {
    return {
      cancellationFeeEnabled: false,
      depositsEnabled: false,
      collectCardInformation: false,
    };
  }

  const {
    cancellationFeePolicyEnabled,
    cancellationFeeRequiredFor,
    allowDeposits,
    depositsRequiredFor,
  } = medspaConfiguration;

  const { onlineBookingDepositsV1Enabled, onlyRequireCcForNewClientsEnabled } =
    enabledFeatures;

  const isNewClient = !isReturningClient;
  const requireForAllOrNewClient = (requiredFor: RequiredForChoices) =>
    !onlyRequireCcForNewClientsEnabled ||
    getRadioValue(requiredFor) === getRadioValue(RequiredForChoices.All) ||
    isNewClient;

  const cancellationFeeEnabled =
    cancellationFeePolicyEnabled &&
    requireForAllOrNewClient(cancellationFeeRequiredFor as RequiredForChoices);

  const depositsEnabled =
    onlineBookingDepositsV1Enabled &&
    allowDeposits &&
    requireForAllOrNewClient(depositsRequiredFor as RequiredForChoices);

  const collectCardInformation = cancellationFeeEnabled || depositsEnabled;

  return {
    cancellationFeeEnabled,
    depositsEnabled,
    collectCardInformation,
  };
};

export default useBookingCCRequiredFlags;
